import React, { useState } from 'react';

const ParagraphPicker = ({ textAlign, lineHeight, letterSpacing, paragraphSpacing, onChange }) => {
  const [localTextAlign, setLocalTextAlign] = useState(textAlign);
  const [localLineHeight, setLocalLineHeight] = useState(lineHeight);
  const [localLetterSpacing, setLocalLetterSpacing] = useState(letterSpacing);
  const [localParagraphSpacing, setLocalParagraphSpacing] = useState(paragraphSpacing);

  const handleChange = (property, value) => {
    const newState = {
      textAlign: localTextAlign,
      lineHeight: localLineHeight,
      letterSpacing: localLetterSpacing,
      paragraphSpacing: localParagraphSpacing,
      [property]: value
    };
    
    if (property === 'textAlign') setLocalTextAlign(value);
    if (property === 'lineHeight') setLocalLineHeight(value);
    if (property === 'letterSpacing') setLocalLetterSpacing(value);
    if (property === 'paragraphSpacing') setLocalParagraphSpacing(value);
    
    onChange(newState);
  };

  const alignments = [
    { name: 'Left', value: 'left', symbol: '≡' },
    { name: 'Center', value: 'center', symbol: '≣' },
    { name: 'Right', value: 'right', symbol: '≡' },
    { name: 'Justify', value: 'justify', symbol: '≣' }
  ];

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Text Align</label>
        <div className="flex gap-1">
          {alignments.map((align) => (
            <button
              key={align.value}
              onClick={() => handleChange('textAlign', align.value)}
              className={`flex-1 px-2 py-1.5 rounded text-center transition-colors ${
                localTextAlign === align.value 
                  ? 'bg-gray-300 text-gray-800' 
                  : 'text-gray-300 hover:bg-gray-600'
              }`}
              style={{ 
                fontSize: '7px',
                backgroundColor: localTextAlign === align.value ? undefined : '#4a4a4a',
                fontFamily: 'monospace',
                lineHeight: '0.8'
              }}
              title={align.name}
            >
              {align.value === 'left' && (
                <div style={{ width: '100%', padding: '2px' }}>
                  <div style={{ borderTop: '1px solid currentColor', width: '80%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '80%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '60%' }}></div>
                </div>
              )}
              {align.value === 'center' && (
                <div style={{ width: '100%', padding: '2px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ borderTop: '1px solid currentColor', width: '70%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '80%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '60%' }}></div>
                </div>
              )}
              {align.value === 'right' && (
                <div style={{ width: '100%', padding: '2px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <div style={{ borderTop: '1px solid currentColor', width: '80%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '80%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '60%' }}></div>
                </div>
              )}
              {align.value === 'justify' && (
                <div style={{ width: '100%', padding: '2px' }}>
                  <div style={{ borderTop: '1px solid currentColor', width: '100%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '100%', marginBottom: '4px' }}></div>
                  <div style={{ borderTop: '1px solid currentColor', width: '100%' }}></div>
                </div>
              )}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Line Height</label>
        <div className="flex items-center gap-1">
          <input
            type="number"
            value={localLineHeight}
            onChange={(e) => handleChange('lineHeight', parseFloat(e.target.value) || 1.2)}
            className="flex-1 bg-gray-700 text-gray-300 px-2 py-1 rounded border border-gray-600"
            style={{ fontSize: '14px', height: '24px', backgroundColor: '#4a4a4a' }}
            min="0.8"
            max="3"
            step="0.1"
            placeholder="1.2 em"
          />
        </div>
      </div>

      <div>
        <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Letter Spacing</label>
        <div className="flex items-center gap-1">
          <input
            type="number"
            value={localLetterSpacing}
            onChange={(e) => handleChange('letterSpacing', parseFloat(e.target.value) || 0)}
            className="flex-1 bg-gray-700 text-gray-300 px-2 py-1 rounded border border-gray-600"
            style={{ fontSize: '14px', height: '24px', backgroundColor: '#4a4a4a' }}
            min="-2"
            max="10"
            step="0.1"
            placeholder="0 px"
          />
        </div>
      </div>

      <div>
        <label className="block text-gray-300 mb-1" style={{ fontSize: '9px' }}>Paragraph Spacing</label>
        <div className="flex items-center gap-1">
          <input
            type="number"
            value={localParagraphSpacing}
            onChange={(e) => handleChange('paragraphSpacing', parseFloat(e.target.value) || 0)}
            className="flex-1 bg-gray-700 text-gray-300 px-2 py-1 rounded border border-gray-600"
            style={{ fontSize: '14px', height: '24px', backgroundColor: '#4a4a4a' }}
            min="0"
            max="50"
            step="1"
            placeholder="0 px"
          />
        </div>
      </div>
    </div>
  );
};

export default ParagraphPicker;
